/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teal_Keen_Javelina_WaveInputs */

const fr_teal_keen_javelina_wave = /** @type {(inputs: Teal_Keen_Javelina_WaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les notifications ne sont pas activées sur ce site, souhaitez vous les activer ?`)
};

/**

* @param {Teal_Keen_Javelina_WaveInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const teal_keen_javelina_wave = /** @type {((inputs?: Teal_Keen_Javelina_WaveInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teal_Keen_Javelina_WaveInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_teal_keen_javelina_wave(inputs)
});